import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderManualDeliveryAddressDto
*  Адрес доставки.
*/
export class OrderManualDeliveryAddressDto extends ActiveModel {

/**
  * postalCode
  * Почтовый индекс.
  */
  @ActiveField('')
  postalCode: string = ''


/**
  * city
  * Город.
  */
  @ActiveField('')
  city: string = ''


/**
  * street
  * Улица.
  */
  @ActiveField('')
  street: string = ''


/**
  * house
  * Дом/строение.
  */
  @ActiveField('')
  house: string = ''


/**
  * apartment
  * Квартира / офис; опционально (частный сектор).
  */
  @ActiveField(null)
  apartment: null | string = null
}
